import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import View from "./view";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { LoadingAFY, position, typeAlert, typeLoaders, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { sponsor } from "../../store/sponsor/actions";
import showToast from "../../services/toast";
import { themeCore } from "../../assets/themes/theme";
import LocalStorageService from "../../services/localStorage";
import { GetProjectAll } from "../../fnx/project/projectAll";
import { postCollection, postCollectionClearData } from "../../store/actions";
import { getCollection } from "../../resources/helper/collection";
import { useStyles } from "./style";
import "./style.css";
import { projectClearData } from "../../store/project/actions";
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
var GenerateBilling = function () {
    var _a, _b, _c, _d;
    var state = useLocation().state;
    var readOnly = (_a = state === null || state === void 0 ? void 0 : state.readOnly) !== null && _a !== void 0 ? _a : false;
    var id = (_b = state === null || state === void 0 ? void 0 : state.id) !== null && _b !== void 0 ? _b : false;
    var dispatch = useDispatch();
    var clientId = React.useState((_d = (_c = lsLogin.getUserLoginStored()) === null || _c === void 0 ? void 0 : _c.clientId) !== null && _d !== void 0 ? _d : "")[0];
    var classes = useStyles();
    var navigate = useNavigate();
    var _e = React.useState([]), sponsorList = _e[0], setSponsorList = _e[1];
    var _f = React.useState(true), enable = _f[0], setEnable = _f[1];
    var _g = React.useState(1), page = _g[0], setPage = _g[1];
    var _h = React.useState(5000), limit = _h[0], setLimit = _h[1];
    var _j = useState([]), rows = _j[0], setRows = _j[1];
    var _k = useState(0), resetVersion = _k[0], setResetVersion = _k[1];
    var _l = React.useState(""), sponsorsIds = _l[0], setSponsorsIds = _l[1];
    var _m = React.useState(false), loading = _m[0], setLoading = _m[1];
    var _o = React.useState(false), trigger = _o[0], setTrigger = _o[1];
    var _p = React.useState(false), triggerProject = _p[0], setTriggerProject = _p[1];
    var _q = useState(1), insurancePage = _q[0], setInsurancePage = _q[1];
    var _r = useState(20), insuranceLimit = _r[0], setInsuranceLimit = _r[1];
    var _s = useState(""), status = _s[0], setStatus = _s[1];
    var _t = useState(""), month = _t[0], setMonth = _t[1];
    var _u = useState(null), collection = _u[0], setCollection = _u[1];
    var _v = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _v[0], setSeeToast = _v[1];
    var _w = React.useState([]), insurancesList = _w[0], setInsurancesList = _w[1];
    var today = new Date();
    //Periodos maximos a cobrar
    var _x = React.useState("3"), numberMaximumValue = _x[0], setNumberMaximumValue = _x[1];
    //Numero maximo de facturas por poliza
    var _y = React.useState("3"), numberMaximumInvoicesValue = _y[0], setNumberMaximumInvoicesValue = _y[1];
    //Numero de meses a cancelar
    var _z = React.useState("3"), cancelAfterValue = _z[0], setCancelAfterValue = _z[1];
    //Separar archivos por producto
    var _0 = React.useState(false), splitArchivesPerProductValue = _0[0], setSplitArchivesPerProductValue = _0[1];
    //No cancelar polizas vencidas
    var _1 = React.useState(false), noCancelExpiredPolicyValue = _1[0], setNoCancelExpiredPolicyValue = _1[1];
    //No cancelar polizas vencidas por edad
    var _2 = React.useState(false), noExpiredPolicyAgeValue = _2[0], setNoExpiredPolicyAgeValue = _2[1];
    //Solo recobranza (no nuevas notas de cobro)
    var _3 = React.useState(false), justNewInvoiceNoRebillValue = _3[0], setJustNewInvoiceNoRebillValue = _3[1];
    //Solo nuevas notas de cobro (no recobranza)
    var _4 = React.useState(false), justRebillNoNewInvoiceValue = _4[0], setJustRebillNoNewInvoiceValue = _4[1];
    var _5 = useState(false), dataLoaded = _5[0], setDataLoaded = _5[1];
    var _6 = React.useState([]), type = _6[0], setType = _6[1];
    var types = [
        {
            id: "GENERAL",
            name: "Cobranza General",
            value: "GENERAL",
        },
        {
            id: "NEW",
            name: "Nuevos cobros",
            value: "NEW",
        },
        {
            id: "REBILLING",
            name: "Recobranza únicamente",
            value: "REBILLING",
        },
    ];
    var formattedToday = "".concat(today.getFullYear(), "-").concat(String(today.getMonth() + 1).padStart(2, "0"), "-").concat(String(today.getDate()).padStart(2, "0"));
    var handleOnClickNext = function (data) {
        var _a, _b;
        var projectsId = data.sponsors;
        if (projectsId.length > 0) {
            projectsId = projectsId.map(function (item) { return item.id; });
        }
        var dataCollection = {
            actualMonth: data.cobranzaMonthDate == "" ? formattedToday : data.cobranzaMonthDate,
            cancelMonth: parseInt(data.cancelAfter),
            maxInvoicesPerPolicy: parseInt(data.numberMaximumInvoices),
            projectsId: projectsId,
            filePerProduct: !!data.splitArchivesPerProduct,
            userId: (_b = (_a = lsLogin.getUserLoginStored()) === null || _a === void 0 ? void 0 : _a.userId) !== null && _b !== void 0 ? _b : "",
            billingType: data.tipoCobranza,
            noCancelPolicy: !!data.noCancelExpiredPolicy,
            maxRebillingMonths: parseInt(data.numberMaximum),
        };
        if (data.sponsors.length > 0) {
            setLoading(true);
            dispatch(postCollection(dataCollection));
        }
        else {
            setSeeToast({
                show: true,
                type: typeAlert.error,
                message: "No hay proyectos seleccionados.",
            });
        }
    };
    var _7 = useSelector(function (state) {
        var _a;
        return ({
            responseSponsor: (_a = state.Sponsor.responseSponsor) === null || _a === void 0 ? void 0 : _a.data,
            errorSponsor: state.Sponsor.errorSponsor,
            loadingSponsor: state.Sponsor.loadingSponsor,
        });
    }), responseSponsor = _7.responseSponsor, errorSponsor = _7.errorSponsor, loadingSponsor = _7.loadingSponsor;
    var _8 = useSelector(function (state) { return ({
        responseCollection: state.Collections.responsePostCollection,
        errorCollection: state.Collections.errorPostCollection,
        loadingCollection: state.Collections.loadingPostCollection,
    }); }), responseCollection = _8.responseCollection, errorCollection = _8.errorCollection, loadingCollection = _8.loadingCollection;
    var _9 = React.useState(""), nameSearch = _9[0], setNameSearch = _9[1];
    var _10 = GetProjectAll(triggerProject, enable, insurancePage, insuranceLimit, sponsorsIds), responseProject = _10.responseProject, errorProject = _10.errorProject, loadingProject = _10.loadingProject;
    var getEstadoClass = function (estado) {
        switch (estado) {
            case "En Proceso":
                return "estado-en-proceso";
            case "Completado":
                return "estado-completado";
            case "Fallido":
                return "estado-fallido";
            case "Procesando Pagos":
                return "estado-procesando-pagos";
            case "Generando archivo":
                return "estado-generado";
            default:
                return "estado-default";
        }
    };
    useEffect(function () {
        if (responseProject) {
            var newInsurancesList_1 = responseProject.data
                .filter(function (item) { return item.visibleInBilling === true; })
                .map(function (item) {
                var _a, _b, _c;
                return ({
                    id: item.id,
                    type: (_a = item.projectTypeInfo) === null || _a === void 0 ? void 0 : _a.description,
                    sponsor: (_b = item.fkSponsor) === null || _b === void 0 ? void 0 : _b.name,
                    product: item.description,
                    currency: (_c = item.fkCurrency) === null || _c === void 0 ? void 0 : _c.countryCode,
                });
            });
            if (readOnly) {
                setLoading(true);
                getCollection(id)
                    .then(function (res) {
                    var _a, _b, _c, _d, _e;
                    var selectedType = types.find(function (type) { return type.value === res.parameters.billingType; });
                    if (selectedType) {
                        setType([selectedType]);
                    }
                    setMonth(res.parameters.actualMonth);
                    setLoading(false);
                    setStatus(getStatusLabel(res.status));
                    setCollection(res);
                    setNumberMaximumInvoicesValue((_a = res.parameters.maxInvoicesPerPolicy) !== null && _a !== void 0 ? _a : "0");
                    setCancelAfterValue((_b = res.parameters.cancelMonth) !== null && _b !== void 0 ? _b : "0");
                    setNumberMaximumValue((_c = res.parameters.maxRebillingMonths) !== null && _c !== void 0 ? _c : "0");
                    setSplitArchivesPerProductValue((_d = res.parameters.filePerProduct) !== null && _d !== void 0 ? _d : false);
                    setNoCancelExpiredPolicyValue((_e = res.parameters.noCancelPolicy) !== null && _e !== void 0 ? _e : false);
                    //No vienen
                    //setNoExpiredPolicyAgeValue(res.parameters.noCancelPolicy ?? false);
                    setJustNewInvoiceNoRebillValue(false);
                    setJustRebillNoNewInvoiceValue(false);
                    var filteredSponsorList = newInsurancesList_1.filter(function (sponsor) {
                        return res.parameters.projectsId.includes(sponsor.id);
                    });
                    setInsurancesList(filteredSponsorList);
                    setDataLoaded(true);
                })
                    .catch(function (err) {
                    setLoading(false);
                    console.log("Error al obtener la cobranza", err);
                });
            }
            else {
                setInsurancesList(newInsurancesList_1);
                setType(types);
                setMonth(formattedToday);
                setSplitArchivesPerProductValue(false);
                setNoCancelExpiredPolicyValue(false);
                setNoExpiredPolicyAgeValue(false);
                setJustNewInvoiceNoRebillValue(false);
                setJustRebillNoNewInvoiceValue(false);
                setDataLoaded(true);
            }
            dispatch(projectClearData());
        }
    }, [responseProject]);
    useEffect(function () {
        dispatch(sponsor({
            enable: enable,
            page: page,
            limit: limit,
            clientId: clientId,
        }));
        setTrigger(true);
    }, []);
    //Llena la data para el filtro de los sponsor
    useEffect(function () {
        if (responseSponsor && (responseSponsor === null || responseSponsor === void 0 ? void 0 : responseSponsor.length) > 0) {
            var newSponsorList = responseSponsor.map(function (item) { return ({
                id: item.id,
                name: item.name,
                value: item.id,
                active: false,
            }); });
            setSponsorList(newSponsorList);
            var idSponsor = responseSponsor
                .map(function (item) { return item.id; })
                .join("&sponsorId=");
            setSponsorsIds(idSponsor);
            setTriggerProject(true);
        }
    }, [responseSponsor]);
    var getStatusLabel = function (estado) {
        switch (estado) {
            case "BANK_PAYMENT_PENDING":
                return "En Proceso";
            case "COMPLETED":
                return "Completado";
            case "FAILED":
                return "Fallido";
            case "PROCESSING_BANK_FILE":
                return "Procesando Pagos";
            case "GENERATING_BANK_FILE":
                return "Generando archivo";
            default:
                return estado;
        }
    };
    useEffect(function () {
        if (responseCollection) {
            setTimeout(function () {
                dispatch(postCollectionClearData());
                setLoading(false);
                navigate("/admin/cobranza");
            }, 2000);
        }
    }, [responseCollection]);
    useEffect(function () {
        if (errorCollection) {
            setLoading(false);
            setSeeToast({
                show: true,
                type: typeAlert.error,
                message: errorCollection
                    ? errorCollection
                    : "Error al generar el cobro.",
            });
        }
    }, [errorCollection]);
    var clickBack = function () {
        navigate("/admin/cobranza");
    };
    var handleDefaultValues = function () {
        setNumberMaximumInvoicesValue("3");
        setCancelAfterValue("3");
        setNumberMaximumValue("3");
        setSplitArchivesPerProductValue(false);
        setNoCancelExpiredPolicyValue(false);
        setNoExpiredPolicyAgeValue(false);
        setJustNewInvoiceNoRebillValue(false);
        setJustRebillNoNewInvoiceValue(false);
        setMonth(formattedToday);
        setResetVersion(function (prev) { return prev + 1; }); // Increment to force re-render
    };
    return (_jsxs(React.Fragment, { children: [seeToast.show &&
                showToast(position.topRight, seeToast.type, seeToast.message, function () {
                    setSeeToast({ show: false, message: "", type: typeAlert.success });
                }), _jsx(LoadingAFY, { loading: loading, backgroundColor: themeCore.colors.backgroundLoader, typeAnimation: typeLoaders.LogoAfy, sizeAnimation: 65, textLoading: "Cargando...", textLoadingColor: themeCore.colors.third, spinnerColor: themeCore.colors.third }), dataLoaded && (_jsx(View, { title: readOnly ? "Detalle de Solicitud" : "Generar Cobros", status: getEstadoClass(status), estado: status, onClickBack: clickBack, onClickNext: handleOnClickNext, products: insurancesList, readOnly: readOnly, mes: month, numberMaximumValue: numberMaximumValue, numberMaximumInvoicesValue: numberMaximumInvoicesValue, splitArchivesPerProductValue: splitArchivesPerProductValue, cancelAfterValue: cancelAfterValue, noCancelExpiredPolicyValue: noCancelExpiredPolicyValue, noExpiredPolicyAgeValue: noExpiredPolicyAgeValue, justNewInvoiceNoRebillValue: justNewInvoiceNoRebillValue, justRebillNoNewInvoiceValue: justRebillNoNewInvoiceValue, data: insurancesList, type: type, onClickDefaultValues: handleDefaultValues, collection: collection }, resetVersion))] }));
};
export default GenerateBilling;
